export default "__VITE_ASSET__D$7FIeTd__"